export default "__VITE_ASSET__BNAByDK5__"